/**
 * FairTooltip — RedisiginProductPage Tooltip (1:1457)
 * Desktop hover · 300ms show · hide immediate (notes 1:1461 · 31:5188)
 * Compact tap · no delay · auto-dismiss 3–4s or tap-away (note 31:4443)
 */

import { FAIR_RD_DESKTOP_MIN_WIDTH } from './redesign.data'

export const FAIR_TOOLTIP_SHOW_DELAY_MS = 300

/** Mid of Figma 3–4s compact auto-dismiss */
export const FAIR_TOOLTIP_TAP_DISMISS_MS = 3500

export const FAIR_TOOLTIP_PLACEMENTS = ['top', 'bottom', 'left', 'right'] as const
export type FairTooltipPlacement = (typeof FAIR_TOOLTIP_PLACEMENTS)[number]

export const FAIR_TOOLTIP_TRIGGERS = ['hover', 'tap', 'auto'] as const
export type FairTooltipTrigger = (typeof FAIR_TOOLTIP_TRIGGERS)[number]
export type FairTooltipResolvedTrigger = 'hover' | 'tap'

export const FAIR_TOOLTIP_MAX_WIDTH_PX = 240

export const FAIR_TOOLTIP_HOVER_MEDIA = `(min-width: ${FAIR_RD_DESKTOP_MIN_WIDTH}px)`

export function resolveFairTooltipTrigger(
  trigger: FairTooltipTrigger,
  viewportWidth: number,
): FairTooltipResolvedTrigger {
  if (trigger === 'hover' || trigger === 'tap') {
    return trigger
  }
  return viewportWidth < FAIR_RD_DESKTOP_MIN_WIDTH ? 'tap' : 'hover'
}
